/**
 * Learning & Development Module Routes
 */

import { Routes, Route, Navigate } from 'react-router-dom'
import TrainingRepositoryPage from './pages/TrainingRepositoryPage'
import MyTrainingRecordsPage from './pages/MyTrainingRecordsPage'
import AddTrainingRecordPage from './pages/AddTrainingRecordPage'
import TrainingDetailPage from './pages/TrainingDetailPage'
import TrainingEditPage from './pages/TrainingEditPage'
import TrainingRecordDetailPage from './pages/TrainingRecordDetailPage'
import TrainingCategoriesPage from './pages/TrainingCategoriesPage'
import AllTrainingRecordsPage from './pages/AllTrainingRecordsPage'
import TrainingRequirementsPage from './pages/TrainingRequirementsPage'
import EmployeeRequirementDetailPage from './pages/EmployeeRequirementDetailPage'
import TrainingReportPage from './pages/TrainingReportPage'
import MyCertificationsPage from './pages/MyCertificationsPage'
import EmployeeLearningProfilePage from './pages/EmployeeLearningProfilePage'
import LearningByEmployeePage from './pages/LearningByEmployeePage'

const LearningModule = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="my-records" replace />} />
      <Route path="my-records" element={<MyTrainingRecordsPage />} />
      <Route path="certifications" element={<MyCertificationsPage />} />
      <Route path="records/new" element={<AddTrainingRecordPage />} />
      <Route path="records/:recordId" element={<TrainingRecordDetailPage />} />
      <Route path="trainings" element={<TrainingRepositoryPage />} />
      <Route path="trainings/new" element={<TrainingEditPage />} />
      <Route path="trainings/:trainingId" element={<TrainingDetailPage />} />
      <Route path="trainings/:trainingId/edit" element={<TrainingEditPage />} />
      {/* Redirect old verification URL to all-records */}
      <Route path="verification" element={<Navigate to="/learning/all-records" replace />} />
      <Route path="all-records" element={<AllTrainingRecordsPage />} />
      <Route path="records" element={<AllTrainingRecordsPage />} />
      <Route path="categories" element={<TrainingCategoriesPage />} />
      <Route path="requirements" element={<TrainingRequirementsPage />} />
      <Route path="requirements/:employeeId" element={<EmployeeRequirementDetailPage />} />
      <Route path="employees" element={<LearningByEmployeePage />} />
      <Route path="employees/:employeeId" element={<EmployeeLearningProfilePage />} />
      <Route path="reports" element={<TrainingReportPage />} />
    </Routes>
  )
}

export default LearningModule
